export default __webpack_public_path__ + "static/media/Skup Pula (16).ac707449.JPG";